<template>
    <span>
        ASD
    </span>
</template>

<script>
export default {
}
</script>

<style lang="scss">
@import '../assets/scss/_variables.scss';
</style>



// WEBPACK FOOTER //
// avatarLoader.vue?5c8439be